import {useEffect, useState} from "react";
import httpService from "../../services/httpService";
import posthog from 'posthog-js';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import { useNavigate, Link, useParams } from "react-router-dom";
import "../../styles/clubWizard.scss";
import StepIntro from "./steps/StepIntro";
import StepTitles from "./steps/StepTitles";
import StepSkills from "./steps/StepSkills";
import StepClubEpisodes from "./steps/StepClubEpisodes";
import StepEpisodesInsights from "./steps/StepEpisodesInsights";
import StepEpisodesDiscussions from "./steps/StepEpisodesDiscussions";
import StepScheduleEpisodes from "./steps/StepScheduleEpisodes";
import StepImages from "./steps/StepImages";
import StepChoice from "./steps/StepChoice";

const ClubWizard = () => {
    const { step, id } = useParams();
    const [wizardStep, setWizardStep] = useState(step??'start');
    const [podcastClub, setPodcastClub] = useState(null);
    const [hasTestingClub, setHasTestingClub] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        httpService.get('/dash/has-testing-club')
            .then(res => setHasTestingClub(res.data.has_testing_club))
            .catch(() => setHasTestingClub(false));
    }, []);

    useEffect(() => {
        console.log('wizard useEffect executed')
    }, [podcastClub]);

    const handleStateChange = (step, club_guid=null) => {
        let s = '';
        if(step > 6){
            posthog.capture('podcast_club_wizard_completed', {
                club_guid: club_guid ?? id ?? null,
            });
            navigate('/podcaster-dashboard');
        } else {
            s = step ?? 'start';
        }

        const podcast_club_id = '/'+(club_guid ? club_guid : id ?? '');
        const route = '/wizard/'+s+podcast_club_id;
        navigate(route)
    };

    const handlePodcastClubChange = (pc) => {
        setPodcastClub(pc)
    }

    if (hasTestingClub === null) {
        return (
            <div className="d-flex justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    const componentMap = {
        choice: <StepChoice onStageChange={handleStateChange} onClubChange={handlePodcastClubChange} podcastClub={podcastClub} />,
        start: <StepIntro onStageChange={handleStateChange} onClubChange={handlePodcastClubChange} podcastClub={podcastClub} hasTestingClub={hasTestingClub} />,
        1: <StepTitles onStageChange={handleStateChange} onClubChange={handlePodcastClubChange} podcastClub={podcastClub} hasTestingClub={hasTestingClub} />,
        // 2: <StepImages onStageChange={handleStateChange} onClubChange={handlePodcastClubChange} podcastClub={podcastClub} />,
        2: <StepSkills onStageChange={handleStateChange} onClubChange={handlePodcastClubChange} podcastClub={podcastClub} />,
        3: <StepClubEpisodes onStageChange={handleStateChange} onClubChange={handlePodcastClubChange} podcastClub={podcastClub} />,
        4: <StepEpisodesInsights onStageChange={handleStateChange} onClubChange={handlePodcastClubChange} podcastClub={podcastClub} />,
        5: <StepEpisodesDiscussions onStageChange={handleStateChange} onClubChange={handlePodcastClubChange} podcastClub={podcastClub} />,
        6: <StepScheduleEpisodes onStageChange={handleStateChange} onClubChange={handlePodcastClubChange} podcastClub={podcastClub} />
    };
    return (
        <div id={"wizard"} className={"py-3 px-3 component-ClubWizard"}>
            <Row className={"d-flex"}>
                <Col md={10}>
                    <Card className={"p-3 pb-0"}>
                        <Image fluid src={"/img/audience-2-wide.jpg"} fluid className={"mb-3"} />
                        <div id={"registration-stepper"} className={''}>
                            {componentMap[wizardStep]}
                        </div>
                    </Card>
                </Col>
                <Col md={2} id={'animated-casette-wrapper'} className={"ps-sm-2 d-sm-none d-md-flex"}>
                    <Card id={"animated-background"} className={"w-100 card-bg-kenburns"} style={{
                        backgroundImage: "url('/img/casette-bg.jpg')"
                    }}>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default ClubWizard;
